import React from "react";

const PackageCreditTextBlock = (props: {title: string; subtitle: string}) => {
    return (
        <div className={"font-medium text-xs text-black p-1"}>
            <p>
                <span className={"font-semibold"}>{props.title}</span>
                <br />
                <br />
                <span>{props.subtitle}</span>
            </p>
        </div>
    );
};

export default PackageCreditTextBlock;
